/* API Client Library */
let self = module.exports = {
  fixUrl(currentUrl) {
    if (currentUrl.startsWith("/"))
    {
      var baseUrl = document.getElementsByTagName('base')[0].href;
      baseUrl = baseUrl.endsWith("/") ? baseUrl.substring(0, baseUrl.length - 1) : baseUrl;
      return `${baseUrl}${currentUrl}`;
    }
    return currentUrl;
  },
  dummy: {
    statusCode(code, errorMessage) {
      let url = `/api/dummy/${code}`;
      let params = { };
      if (errorMessage) {
        params['errorMessage'] = errorMessage;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    }
  },
  lookup: {
    getTypes() {
      let url = `/api/lookup`;
      return Vue.http.get(self.fixUrl(url));
    },
    getType(lookupTypeName) {
      let url = `/api/lookup/${appHelpers.url.encode(lookupTypeName)}`;
      return Vue.http.get(self.fixUrl(url));
    },
    getEntries(tenantId, lookupTypeName, currentLookupId, addDefaultOption, forceCompanyId, showDeleted) {
      let url = `/api/lookup/${tenantId}/${appHelpers.url.encode(lookupTypeName)}/entries`;
      let params = { };
      if (currentLookupId) {
        params["currentLookupId"] = currentLookupId;
      }
      if (addDefaultOption) {
        params["addDefaultOption"] = true;
      }
      if (forceCompanyId) {
        params["forceCompanyID"] = true;
      }
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    getMultipleEntries(tenantId, requests) {
      let url = `/api/lookup/${tenantId}/multiple/entries`;
      let apiRequests = requests.filter(r => (r != null && r.length)).map(r => {
        let apiRequest = {
          name: r[0]
        };
        if (r.length > 1 && r[1]) {
          apiRequest["returnName"] = r[1];
        }
        if (r.length > 2 && r[2]) {
          apiRequest["currentLookupId"] = r[2];
        }
        if (r.length > 3 && r[3]) {
          apiRequest["addDefaultOption"] = true;
        }
        if (r.length > 4 && r[4]) {
          apiRequest["forceCompanyID"] = true;
        }
        if (r.length > 5 && r[5]) {
          apiRequest["showDeleted"] = true;
        }
        return apiRequest;
      });
      return Vue.http.post(self.fixUrl(url), apiRequests);
    },
    getEntry(tenantId, lookupTypeName, lookupId) {
      let url = `/api/lookup/${tenantId}/${appHelpers.url.encode(lookupTypeName)}/entries/${lookupId}`;
      return Vue.http.get(self.fixUrl(url));
    },
    upsertEntry(tenantId, lookupTypeName, record) {
      let url = `/api/lookup/${tenantId}/${appHelpers.url.encode(lookupTypeName)}/entries/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    deleteEntry(tenantId, lookupTypeName, lookupId) {
      let url = `/api/lookup/${tenantId}/${appHelpers.url.encode(lookupTypeName)}/entries/${lookupId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    restoreEntry(tenantId, lookupTypeName, lookupId) {
      let url = `/api/lookup/${tenantId}/${appHelpers.url.encode(lookupTypeName)}/entries/${lookupId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    },
    sortEntries(tenantId, lookupTypeName, sortBy, showDeleted) {
      let url = `/api/lookup/${tenantId}/${appHelpers.url.encode(lookupTypeName)}/entries/sort`;
      let params = { };
      if (sortBy) {
        params["sortBy"] = sortBy;
      }
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.post(self.fixUrl(url), null, { params: params });
    },
    getPOApprovers(tenantId) {
      let url = `/api/lookup/${tenantId}/poapprover/list`;
      return Vue.http.get(self.fixUrl(url));
    },
  },
  organization: {
    get(organizationId, showDeleted) {
      let url = `/api/organization/`;
      let params = { };
      if (organizationId) {
        url += `${organizationId}/`;
      }
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    upsert(record) {
      let url = `/api/organization/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(organizationId) {
      let url = `/api/organization/${organizationId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    restore(organizationId) {
      let url = `/api/organization/${organizationId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    },
  },
  notification: {
    get(notificationId) {
      let url = `/api/notification/`;
      let params = { };
      if (notificationId) {
        url += `${notificationId}/`;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    upsert(record) {
      let url = `/api/notification/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(organizationId) {
      let url = `/api/notification/${organizationId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    read(notificationId) {
      let url = `/api/notification/${notificationId}/read`;
      return Vue.http.post(self.fixUrl(url));
    },
  },
  feedback: {
    request: {
      getMine(tenantId, filters) {
        let url = `/api/feedback/${tenantId}/request/user/`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      getAll(tenantId, requestId, filters) {
        let url = `/api/feedback/${tenantId}/request/`;
        if (requestId) {
          url += `${requestId}/`;
        }
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      upsert(tenantId, record) {
        let url = `/api/feedback/${tenantId}/request/`;
        if (record.id) {
          url += record.id;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
    }
  },
  cable: {
    get(tenantId, showDeleted, cableId, showPower, showGround, showHDGN, showAll) {
      let url = `/api/cable/${tenantId}/`;
      let params = { };
      if (cableId) {
        url += `${cableId}/`;
      }
      if (typeof(showPower) === "boolean") {
        params["showPower"] = showPower;
      }
      if (typeof(showGround) === "boolean") {
        params["showGround"] = showGround;
      }
      if (typeof(showHDGN) === "boolean") {
        params["showHDGN"] = showHDGN;
      }
      if (typeof(showAll) === "boolean") {
        params["showAll"] = showAll;
      }
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    filterPreviousRequest: null,
    filter(tenantId, showDeleted, searchText, recordLimit, showPower, showGround, showHDGN, showAll, lookupInsulationTypeId, lookupAmpId) {
      let url = `/api/cable/${tenantId}/filter`;
      let params = { };
      if (searchText) {
        params["searchText"] = searchText;
      }
      if (recordLimit) {
        params["recordLimit"] = recordLimit;
      }
      if (typeof(showPower) === "boolean") {
        params["showPower"] = showPower;
      }
      if (typeof(showGround) === "boolean") {
        params["showGround"] = showGround;
      }
      if (typeof(showHDGN) === "boolean") {
        params["showHDGN"] = showHDGN;
      }
      if (typeof(showAll) === "boolean") {
        params["showAll"] = showAll;
      }
      if (lookupInsulationTypeId) {
        params["lookupInsulationTypeId"] = lookupInsulationTypeId;
      }
      if (lookupAmpId) {
        params["lookupAmpId"] = lookupAmpId;
      }
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
        if (self.cable.filterPreviousRequest) {
          self.cable.filterPreviousRequest.abort();
        }

        self.cable.filterPreviousRequest = request;
      }});
    },
    upsert(tenantId, record) {
      let url = `/api/cable/${tenantId}/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(tenantId, cableId) {
      let url = `/api/cable/${tenantId}/${cableId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    restore(tenantId, cableId) {
      let url = `/api/cable/${tenantId}/${cableId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    },
  },
  housing: {
    get(tenantId, showDeleted, housingId) {
      let url = `/api/housing/${tenantId}/`;
      let params = { };
      if (housingId) {
        url += `${housingId}/`;
      }
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    upsert(tenantId, record) {
      let url = `/api/housing/${tenantId}/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(tenantId, housingId) {
      let url = `/api/housing/${tenantId}/${housingId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    restore(tenantId, housingId) {
      let url = `/api/housing/${tenantId}/${housingId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    },
    filterPreviousRequest: null,
    filter(tenantId, searchText, recordLimit, lookupVoltId, lookupWireId, lookupOperatingTempId, lookupAmpId, isCSA) {
      let url = `/api/housing/${tenantId}/filter`;
      let params = { };
      if (searchText) {
        params["searchText"] = searchText;
      }
      if (recordLimit) {
        params["recordLimit"] = recordLimit;
      }
      if (lookupVoltId) {
        params["lookupVoltId"] = lookupVoltId;
      }
      if (lookupWireId) {
        params["lookupWireId"] = lookupWireId;
      }
      if (lookupOperatingTempId) {
        params["lookupOperatingTempId"] = lookupOperatingTempId;
      }
      if (lookupAmpId) {
        params["lookupAmpId"] = lookupAmpId;
      }
      if (typeof(isCSA) === "boolean")
      {
        params["isCSA"] = isCSA;
      }
      return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
        if (self.housing.filterPreviousRequest) {
          self.housing.filterPreviousRequest.abort();
        }

        self.housing.filterPreviousRequest = request;
      }});
    },
  },
  quoteShipment: {
    submit(tenantId, record) {
      let url = `/api/quote-shipment/${tenantId}/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.post(self.fixUrl(url), record);
    },
  },
  irp: {
    get(tenantId, runId) {
      let url = `/api/irp/${tenantId}/run/`;
      let params = { };
      if (runId) {
        url += `${runId}/`;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    upsert(tenantId, record) {
      let url = `/api/irp/${tenantId}/run/`;
      if (record.id) {
        url += record.id;
      }
      let params = { };
      return Vue.http.put(self.fixUrl(url), record, { params: params });
    },
  },
  quoteBus: {
    search(tenantId, filters) {
      let url = `/api/quote-bus/${tenantId}/search`;
      return Vue.http.get(self.fixUrl(url), { params: filters });
    },
    filterPreviousRequest: null,
    filter(tenantId, searchText, customerNumber, projectName, recordLimit) {
      let url = `/api/quote-bus/${tenantId}/filter`;
      let params = { };
      if (searchText) {
        params["searchText"] = searchText;
      }
      if (recordLimit) {
        params["recordLimit"] = recordLimit;
      }
      if (customerNumber) {
        params["customerNumber"] = customerNumber;
      }
      if (projectName) {
        params["projectName"] = projectName;
      }
      return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
        if (self.quoteBus.filterPreviousRequest) {
          self.quoteBus.filterPreviousRequest.abort();
        }

        self.quoteBus.filterPreviousRequest = request;
      }});
    },
    get(tenantId, showDeleted, quoteBusId, simple) {
      let url = `/api/quote-bus/${tenantId}/`;
      let params = { };
      if (quoteBusId) {
        url += `${quoteBusId}/`;
        if (simple) {
          url += 'simple';
        }
      }
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    getBulk(tenantId, quoteNumbers) {
      let url = `/api/quote-bus/${tenantId}/bulk`;
      let params = { quoteNumbers: quoteNumbers };
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    getCosts(tenantId, quoteBusId, params) {
      let url = `/api/quote-bus/${tenantId}/${quoteBusId}/costs`;
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    getDetail(tenantId, showDeleted, quoteBusDetailId) {
      let url = `/api/quote-bus/${tenantId}/detail/${quoteBusDetailId}/`;
      let params = { };
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    getDetailItem(tenantId, showDeleted, quoteBusDetailItemId) {
      let url = `/api/quote-bus/${tenantId}/detail-item/${quoteBusDetailItemId}/`;
      let params = { };
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    getDetailFactor(tenantId, showDeleted, quoteBusDetailFactorId) {
      let url = `/api/quote-bus/${tenantId}/detail-item/${quoteBusDetailFactorId}/`;
      let params = { };
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    upsert(tenantId, record, copyFromQuoteId) {
      let url = `/api/quote-bus/${tenantId}/`;
      if (record.id) {
        url += record.id;
      }
      let params = { };
      if (copyFromQuoteId) {
        params["copyFromQuoteId"] = copyFromQuoteId;
      }
      return Vue.http.put(self.fixUrl(url), record, { params: params });
    },
    updateSalesNotes(tenantId, quoteBusId, record) {
      let url = `/api/quote-bus/${tenantId}/${quoteBusId}/sales-notes`;
      return Vue.http.post(self.fixUrl(url), record);
    },
    upsertDetail(tenantId, record) {
      let url = `/api/quote-bus/${tenantId}/detail/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(tenantId, quoteBusId) {
      let url = `/api/quote-bus/${tenantId}/${quoteBusId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    pasteDetail(tenantId, quoteId, quoteBusDetailIds) {
      let url = `/api/quote-bus/${tenantId}/${quoteId}/detail/paste`;
      return Vue.http.post(self.fixUrl(url), { quoteDetailIdList: quoteBusDetailIds.toString() });
    },
    deleteDetail(tenantId, quoteId, quoteBusDetailIds) {
      let url = `/api/quote-bus/${tenantId}/${quoteId}/detail`;
      return Vue.http.delete(self.fixUrl(url), { body: { quoteDetailIdList: quoteBusDetailIds.toString() } });
    },
    restore(tenantId, quoteBusId) {
      let url = `/api/quote-bus/${tenantId}/${quoteBusId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    },
    generateDetailBOM(tenantId, record, parameters) {
      let url = `/api/quote-bus/${tenantId}/detail/bom/generate`;
      return Vue.http.post(self.fixUrl(url), record, { params: parameters });
    },
    priceDetail(tenantId, record) {
      let url = `/api/quote-bus/${tenantId}/detail/price`;
      return Vue.http.post(self.fixUrl(url), record);
    },
    adjustPrice(tenantId, record, parameters) {
      let url = `/api/quote-bus/${tenantId}/adjust-price`;
      return Vue.http.post(self.fixUrl(url), record, { params: parameters });
    },
    updateItemPrices(tenantId, quoteBusId) {
      let url = `/api/quote-bus/${tenantId}/${quoteBusId}/update-item-prices`;
      return Vue.http.post(self.fixUrl(url));
    },
    getSnapshots(tenantId, quoteBusId) {
      let url = `/api/quote-bus/${tenantId}/${quoteBusId}/snapshots`;
      return Vue.http.get(self.fixUrl(url));
    },
    createSnapshot(tenantId, quoteBusId) {
      let url = `/api/quote-bus/${tenantId}/${quoteBusId}/snapshots/create`;
      return Vue.http.post(self.fixUrl(url));
    },
    revertSnapshot(tenantId, quoteBusId, quotePriceHistoryId) {
      let url = `/api/quote-bus/${tenantId}/${quoteBusId}/snapshots/revert/${quotePriceHistoryId}`;
      return Vue.http.post(self.fixUrl(url));
    },
    bulkUpdate(tenantId, quoteIds, status, projectName) {
      let url = `/api/quote-bus/${tenantId}/bulkUpdate`;
      let parameters = {
        quoteIds: quoteIds ? quoteIds.join(',') : null,
        status: status,
        projectName: projectName
      };
      return Vue.http.post(self.fixUrl(url), null, { params: parameters });
    },
    updateJobBudgets(tenantId, quoteBusId, job) {
      let url = `/api/quote-bus/${tenantId}/${quoteBusId}/${job}/update-job-budgets`
      return Vue.http.post(self.fixUrl(url));
    }
  },
  quoteTrayRequest: {
    search(tenantId, filters) {
      let url = `/api/quote-tray-request/${tenantId}/search`;
      return Vue.http.get(self.fixUrl(url), { params: filters });
    },
    get(tenantId, showDeleted, quoteTrayId) {
      let url = `/api/quote-tray-request/${tenantId}/`;
      let params = { };
      if (quoteTrayId) {
        url += `${quoteTrayId}/`;
      }
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    getDetail(tenantId, showDeleted, quoteTrayDetailId) {
      let url = `/api/quote-tray-request/${tenantId}/detail/${quoteTrayDetailId}/`;
      let params = { };
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    getDetailItem(tenantId, showDeleted, quoteTrayDetailItemId) {
      let url = `/api/quote-tray-request/${tenantId}/detail-item/${quoteTrayDetailItemId}/`;
      let params = { };
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    upsert(tenantId, record) {
      let url = `/api/quote-tray-request/${tenantId}/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    upsertDetail(tenantId, record) {
      let url = `/api/quote-tray-request/${tenantId}/detail/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(tenantId, quoteTrayId) {
      let url = `/api/quote-tray-request/${tenantId}/${quoteTrayId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    deleteDetail(tenantId, quoteTrayDetailId) {
      let url = `/api/quote-tray-request/${tenantId}/detail/${quoteTrayDetailId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    restore(tenantId, quoteTrayId) {
      let url = `/api/quote-tray-request/${tenantId}/${quoteTrayId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    },
    restoreDetail(tenantId, quoteTrayDetailId) {
      let url = `/api/quote-tray-request/${tenantId}/detail/${quoteTrayDetailId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    },
    generateDetailBOM(tenantId, record) {
      let url = `/api/quote-tray-request/${tenantId}/detail/bom/generate`;
      return Vue.http.post(self.fixUrl(url), record);
    },
    priceDetail(tenantId, record) {
      let url = `/api/quote-tray-request/${tenantId}/detail/price`;
      return Vue.http.post(self.fixUrl(url), record);
    }
  },
  quoteTrayMatrix: {
    get(tenantId, showDeleted, quoteTrayMatrixId) {
      let url = `/api/quote-tray-matrix/${tenantId}/`;
      let params = { };
      if (quoteTrayMatrixId) {
        url += `${quoteTrayMatrixId}/`;
      }
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    search(tenantId, filters) {
      let url = `/api/quote-tray-matrix/${tenantId}/search`;
      return Vue.http.get(self.fixUrl(url), { params: filters });
    },
    upsert(tenantId, record) {
      let url = `/api/quote-tray-matrix/${tenantId}/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(tenantId, quoteTrayMatrixId) {
      let url = `/api/quote-tray-matrix/${tenantId}/${quoteTrayMatrixId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    restore(tenantId, quoteTrayMatrixId) {
      let url = `/api/quote-tray-matrix/${tenantId}/${quoteTrayMatrixId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    }
  },
  object: {
    get() {
      return Vue.http.get(self.fixUrl('/api/object'));
    }
  },
  function: {
    get() {
      return Vue.http.get(self.fixUrl('/api/function'));
    },
    getModules() {
      return Vue.http.get(self.fixUrl('/api/function/module'));
    },
    getScreens() {
      return Vue.http.get(self.fixUrl('/api/function/screen'));
    },
    getModuleScreens(moduleName) {
      return Vue.http.get(self.fixUrl(`/api/function/module/${moduleName}`));
    },
    getData() {
      return Vue.http.get(self.fixUrl('/api/function/data'));
    },
    upsertData(record) {
      return Vue.http.post(self.fixUrl('/api/function/data'), record);
    }
  },
  role: {
    get(roleId, showDeleted) {
      let url = '/api/role' + (roleId ? `/${roleId}` : '' );
      let params = { };
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    upsert(record) {
      let url = `/api/role/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(roleId) {
      let url = `/api/role/${roleId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    restore(roleId) {
      let url = `/api/role/${roleId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    },
    assignUsers(tenantId, roleId, userIds) {
      let url = `/api/role/${roleId}/assign-users`;
      let params = {
        companyId: tenantId,
        userIds: userIds.join(",")
      };
      return Vue.http.post(self.fixUrl(url), null, { params: params });
    },
    listFunctions(details) {
      let url = `/api/role/list-functions`;
      return Vue.http.post(self.fixUrl(url), details);
    }
  },
  user: {
    get(userId, showDeleted, companyId) {
      let url = '/api/user' + (userId ? `/${userId}` : '' );
      let params =  { };
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      if (companyId) {
        params["companyId"] = companyId;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    upsert(record) {
      let url = `/api/user/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(userId) {
      let url = `/api/user/${userId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
    restore(userId) {
      let url = `/api/user/${userId}/restore`;
      return Vue.http.post(self.fixUrl(url));
    },
    updatePreferences(userId, record) {
      return Vue.http.post(self.fixUrl(`/api/user/${userId}/preference`), record);
    },
    addFunctionFavorite(userId, functionCode) {
      return Vue.http.post(self.fixUrl(`/api/user/${userId}/favorite/${functionCode}`));
    },
    removeFunctionFavorite(userId, functionCode) {
      return Vue.http.delete(self.fixUrl(`/api/user/${userId}/favorite/${functionCode}`));
    },
    filterPreviousRequest: null,
    filter(tenantId, searchText, recordLimit) {
      let url = `/api/user/filter`;
      let params = { };
      if (tenantId) {
        params["companyId"] = tenantId;
      }
      if (searchText) {
        params["searchText"] = searchText;
      }
      if (recordLimit) {
        params["recordLimit"] = recordLimit;
      }
      return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
        if (self.user.filterPreviousRequest) {
          self.user.filterPreviousRequest.abort();
        }

        self.user.filterPreviousRequest = request;
      }});
    },
    listByRole(roleId, showDeleted) {
      let url = `/api/user/byrole/${roleId}`;
      let params = { };
      if (showDeleted) {
        params["showDeleted"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    listFunctions(roles, functionLocks) {
      let url = `/api/user/list-functions`;
      let payload = {
        roles: roles,
        functionLocks: functionLocks,
      }
      return Vue.http.post(self.fixUrl(url), payload);
    }
  },
  setting: {
    get(tenantId, settingId) {
      let url = `/api/setting/${tenantId}` + (settingId ? `/${settingId}` : '' );
      return Vue.http.get(self.fixUrl(url));
    },
    insert(tenantId, record) {
      let url = `/api/setting/${tenantId}`;
      return Vue.http.post(self.fixUrl(url), record);
    },
  },
  link: {
    get(tenantId, linkId) {
      let url = `/api/link/${tenantId}/`;
      if (linkId) {
        url += linkId;
      }
      return Vue.http.get(self.fixUrl(url));
    },
    upsert(tenantId, record) {
      let url = `/api/link/${tenantId}/`;
      if (record.id) {
        url += record.id;
      }
      return Vue.http.put(self.fixUrl(url), record);
    },
    delete(tenantId, linkId) {
      let url = `/api/link/${tenantId}/${linkId}`;
      return Vue.http.delete(self.fixUrl(url));
    },
  },
  shopLoading: {
    getCategories(tenantId) {
      let url = `/api/shopLoading/${tenantId}/category`;
      return Vue.http.get(self.fixUrl(url));
    },
    updateCategories(tenantId, records) {
      let url = `/api/shopLoading/${tenantId}/category`;
      return Vue.http.post(self.fixUrl(url), records);
    }
  },
  stat: {
    download: {
      list(tenantId, name) {
        let url = `/api/stat/${tenantId}/download`;
        let params = { };
        if (name) {
          params["name"] = name;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      }
    }
  },
  tracker: {
    summary(expired) {
      let url = `/api/tracker/summary`;
      let params = { };
      if (expired) {
        params["expired"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    status() {
      let url = `/api/tracker/system`;
      return Vue.http.get(self.fixUrl(url));
    },
    downloads() {
      let url = `/api/tracker/download`;
      return Vue.http.get(self.fixUrl(url));
    },
    list(expired) {
      let url = `/api/tracker/session`;
      let params = { };
      if (expired) {
        params["expired"] = true;
      }
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    get(sessionId) {
      let url = `/api/tracker/session/${sessionId}`;
      return Vue.http.get(self.fixUrl(url));
    },
    getException(exceptionId) {
      let url = `/api/tracker/exception/${exceptionId}`;
      return Vue.http.get(self.fixUrl(url));
    },
    jobs() {
      let url = `/api/tracker/job`;
      return Vue.http/this.get(self.fixUrl(url));
    },
    getJob(jobId) {
      let url = `/api/tracker/job/${jobId}`;
      return Vue.http.get(self.fixUrl(url));
    },
    createJob(title) {
      var formData = new FormData();
      let url = `/api/tracker/job/create`;
      formData.append('title', title);
      return Vue.http.post(self.fixUrl(url), formData);
    },
    deleteJob(jobId) {
      let url = `/api/tracker/job/${jobId}`;
      return Vue.http.delete(self.fixUrl(url));
    }
  },
  url: {
    shorten(target) {
      let url = `/url`;
      let params = { 
        target: target
      };
      return Vue.http.put(self.fixUrl(url), null, { params: params });
    },
  },
  host: {
    select(tenantId, query) {
      let url = `/api/host/${tenantId}/select`;
      let params = {
        query: query
      };
      return Vue.http.get(self.fixUrl(url), { params: params });
    },
    department: {
      getActiveEmployeeCounts(tenantId) {
        let url = `/api/host/${tenantId}/department/employeeCounts`;
        return Vue.http.get(self.fixUrl(url));
      }
    },
    proposal: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/proposal/search`;
        let params = {};
        Object.assign(params, filters);
        if (params.salesPeople) {
          params.salesPeople = params.salesPeople.toString();
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, numberPrefix, recordLimit) {
        let url = `/api/host/${tenantId}/proposal/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.proposal.filterPreviousRequest) {
            self.host.proposal.filterPreviousRequest.abort();
          }
  
          self.host.proposal.filterPreviousRequest = request;
        }});
      },
      update(tenantId, record) {
        let url = `/api/host/${tenantId}/proposal/`;
        if (record.ESTIMATE_NUMBER_ES) {
          url += record.ESTIMATE_NUMBER_ES;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
      updateMarginApproval(tenantId, record) {
        let url = `/api/host/${tenantId}/proposal/${appHelpers.url.encode(record.ESTIMATE_NUMBER_ES)}/marginapproval`;
        return Vue.http.put(self.fixUrl(url), record);
      },
      updateSalesPerson(tenantId, oldSalesPerson, newSalesPerson, status, customerName, customerNameMatchType, customerNumber, customerNumberMatchType) {
        let url = `/api/host/${tenantId}/proposal/action/spupdate`;
        let params = { };
        if (oldSalesPerson) {
          params.oldSalesPerson = oldSalesPerson;
        }
        if (newSalesPerson) {
          params.newSalesPerson = newSalesPerson;
        }
        if (status) {
          params.status = status;
        }
        if (customerName) {
          params.customerName = customerName;
        }
        if (customerNameMatchType) {
          params.customerNameMatchType = customerNameMatchType;
        }
        if (customerNumber) {
          params.customerNumber = customerNumber;
        }
        if (customerNumberMatchType) {
          params.customerNumberMatchType = customerNumberMatchType;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      getDetails(tenantId, number) {
        let url = `/api/host/${tenantId}/proposal/${appHelpers.url.encode(number)}/detail`;
        return Vue.http.get(self.fixUrl(url));
      },
      getCosting(tenantId, number) {
        let url = `/api/host/${tenantId}/proposal/${appHelpers.url.encode(number)}/costing`;
        return Vue.http.get(self.fixUrl(url));
      },
      listFullBOM(tenantId, number, maxLevel, looseMatch, ignoreLength, hideFull, hideFlat) {
        let url = `/api/host/${tenantId}/proposal/${appHelpers.url.encode(number)}/fullBOM`;
        let params = {};
        if (maxLevel) {
          params.maxLevel = maxLevel;
        }
        if (typeof(looseMatch) === "boolean") {
          params.looseMatch = looseMatch;
        }
        if (typeof(ignoreLength) === "boolean") {
          params.ignoreLength = ignoreLength;
        }
        if (typeof(hideFull) === "boolean") {
          params.hideFull = hideFull;
        }
        if (typeof(hideFlat) === "boolean") {
          params.hideFlat = hideFlat;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      createOpportunity(tenantId, number) {
        let url = `/api/host/${tenantId}/proposal/${appHelpers.url.encode(number)}/createOpportunity`;
        return Vue.http.post(self.fixUrl(url));
      },
      getCatalogueInfo(tenantId, estimateNumber, estimateItem, catalogueNumber) {
        let url = `/api/host/${tenantId}/proposal/${appHelpers.url.encode(estimateNumber)}/item/${appHelpers.url.encode(estimateItem)}`;
        let params = {
          catalogueNumber: catalogueNumber
        };
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      searchDetails(tenantId, filters) {
        let url = `/api/host/${tenantId}/proposaldetail/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      analysis(tenantId, filters) {
        let url = `/api/host/${tenantId}/proposal/analysis`;
        let params = {};
        Object.assign(params, filters);
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      searchForecasts(tenantId, filters) {
        let url = `/api/host/${tenantId}/proposalForecast/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      deleteForecasts(tenantId, filters) {
        let url = `/api/host/${tenantId}/proposalForecast`;
        return Vue.http.delete(self.fixUrl(url), { params: filters });
      },
      upsertForecast(tenantId, record) {
        let url = `/api/host/${tenantId}/proposalForecast/`;
        return Vue.http.put(self.fixUrl(url), record);
      },
    },
    opportunity: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/opportunity/search`;
        let params = {};
        Object.assign(params, filters);
        if (params.salesPeople) {
          params.salesPeople = params.salesPeople.toString();
        }
        
        if(params.agents){
          params.agents = params.agents.map(p => p.value).toString();
        }
        
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, numberPrefix, recordLimit) {
        let url = `/api/host/${tenantId}/opportunity/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.opportunity.filterPreviousRequest) {
            self.host.opportunity.filterPreviousRequest.abort();
          }
  
          self.host.opportunity.filterPreviousRequest = request;
        }});
      },
      get(tenantId, number) {
        let url = `/api/host/${tenantId}/opportunity/${appHelpers.url.encode(number)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      getAuditLogs(tenantId, number) {
        let url = `/api/host/${tenantId}/opportunity/${appHelpers.url.encode(number)}/auditLogs`;
        return Vue.http.get(self.fixUrl(url));
      },  
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/opportunity/`;
        if (record.PROPOSAL_PZ) {
          url += record.PROPOSAL_PZ;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
      createChangeOrder(tenantId, record) {
        let url = `/api/host/${tenantId}/opportunity/action/createChangeOrder`;
        return Vue.http.post(self.fixUrl(url), record);
      },
      updateAgingActive(tenantId, salesPerson) {
        let url = `/api/host/${tenantId}/opportunity/action/updateAgingActive`;
        let params = { };
        if (salesPerson) {
          params["salesPerson"] = salesPerson;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      updateSalesPerson(tenantId, oldSalesPerson, newSalesPerson, phase, customerName, customerNameMatchType, customerNumber, customerNumberMatchType) {
        let url = `/api/host/${tenantId}/opportunity/action/spupdate`;
        let params = { };
        if (oldSalesPerson) {
          params.oldSalesPerson = oldSalesPerson;
        }
        if (newSalesPerson) {
          params.newSalesPerson = newSalesPerson;
        }
        if (phase) {
          params.phase = phase;
        }
        if (customerName) {
          params.customerName = customerName;
        }
        if (customerNameMatchType) {
          params.customerNameMatchType = customerNameMatchType;
        }
        if (customerNumber) {
          params.customerNumber = customerNumber;
        }
        if (customerNumberMatchType) {
          params.customerNumberMatchType = customerNumberMatchType;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      updateQuick(tenantId, opportunityNumber, followUpDate, closeDate, probability, productLine, phase, estimator, installDate) {
        let url = `/api/host/${tenantId}/opportunity/action/updateQuick`;
        let params = { };
        if (opportunityNumber) {
          params.opportunityNumber = opportunityNumber;
        }
        if (followUpDate) {
          params.followUpDate = followUpDate;
        }
        if (closeDate) {
          params.closeDate = closeDate;
        }
        if (probability || probability === 0) {
          params.probability = probability;
        }
        if (productLine) {
          params.productLine = productLine;
        }
        if (phase) {
          params.phase = phase;
        }
        if (estimator) {
          params.estimator = estimator;
        }
        if (installDate){
          params.installDate = installDate;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
    },
    budgetaryQuote: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/budgetaryQuote/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      get(tenantId, number) {
        let url = `/api/host/${tenantId}/budgetaryQuote/${appHelpers.url.encode(number)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, customerNumber, numberPrefix, projectName, recordLimit) {
        let url = `/api/host/${tenantId}/budgetaryQuote/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        if (customerNumber) {
          params["customerNumber"] = customerNumber;
        }
        if (projectName) {
          params["projectName"] = projectName;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.budgetaryQuote.filterPreviousRequest) {
            self.host.budgetaryQuote.filterPreviousRequest.abort();
          }
  
          self.host.budgetaryQuote.filterPreviousRequest = request;
        }});
      },
      getCosts(tenantId, number, params) {
        let url = `/api/host/${tenantId}/budgetaryQuote/${appHelpers.url.encode(number)}/costs`;
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      getBulk(tenantId, quoteNumbers) {
        let url = `/api/host/${tenantId}/budgetaryQuote/bulk`;
        let params = { quoteNumbers: quoteNumbers };
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/budgetaryQuote/`;
        if (record.ESTIMATE_NUMBER_ES) {
          url += record.ESTIMATE_NUMBER_ES;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
      updateJobBudgets(tenantId, number, job) {
        let url = `/api/host/${tenantId}/budgetaryQuote/${appHelpers.url.encode(number)}/${job}/update-job-budgets`
        return Vue.http.post(self.fixUrl(url));
      }
    },
    vendorQuote: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/vendorquote/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/vendorquote/`;
        return Vue.http.put(self.fixUrl(url), record);
      },
    },
    listItem: {
      list(tenantId, tableNumber, itemNumber2, description, status, sortByCode, sortByItemNumber2, includeBlankStatuses) {
        let url = `/api/host/${tenantId}/listitems/`;
        if (tableNumber) {
          url += tableNumber;
        }
        var params = { };
        if (itemNumber2) {
          params['itemNumber2'] = itemNumber2;
        }
        if (description) {
          params['description'] = description;
        }
        if (status) {
          params['status'] = status;
        }
        if (sortByCode) {
          params['sortByCode'] = true;
        }
        if (sortByItemNumber2) {
          params['sortByItemNumber2'] = sortByItemNumber2;
        }
        if (includeBlankStatuses) {
          params['includeBlankStatuses'] = includeBlankStatuses;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      listMultiple(tenantId, requests) {
        let url = `/api/host/${tenantId}/listitems/multiple`;
        let apiRequests = requests.filter(r => (r != null && r.length)).map(r => {
          let apiRequest = {
            tableNumber: r[0]
          };
          if (r.length > 1 && r[1]) {
            apiRequest["returnName"] = r[1];
          }
          if (r.length > 2 && r[2]) {
            apiRequest['itemNumber2'] = r[2];
          }
          if (r.length > 3 && r[3]) {
            apiRequest['description'] = r[3];
          }
          if (r.length > 4 && r[4]) {
            apiRequest['status'] = r[4];
          }
          if (r.length > 5 && r[5]) {
            apiRequest['sortByCode'] = true;
          }
          if (r.length > 6 && r[6]) {
            apiRequest['sortByItemNumber2'] = r[6];
          }
          if (r.length > 7 && r[7]) {
            apiRequest['includeBlankStatuses'] = r[7];
          }
          return apiRequest;
        });
        return Vue.http.post(self.fixUrl(url), apiRequests);
      },
      listSets(tenantId, tableNumber) {
        let url = `/api/host/${tenantId}/listitemsets/`;
        let params = { };
        if  (tableNumber || tableNumber === 0) {
          params["tableNumber"] = tableNumber;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      getSetInstructions(tenantId, tableNumber) {
        let url = `/api/host/${tenantId}/listitemsets/instructions/${tableNumber}`;
        return Vue.http.get(self.fixUrl(url));
      },
      getSetPrograms(tenantId, tableNumber) {
        let url = `/api/host/${tenantId}/listitemsets/programs/${tableNumber}`;
        return Vue.http.get(self.fixUrl(url));
      }
    },
    salesPerson: {
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/salePerson`;
        return Vue.http.put(self.fixUrl(url), record);
      }
    },
    note: {
      getSalesNotes(tenantId, setCode, searchKey) {
        let url = `/api/host/${tenantId}/sales/notes/${appHelpers.url.encode(setCode)}/${appHelpers.url.encode(searchKey)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsertSalesNotes(tenantId, setCode, searchKey, noteLines) {
        let url = `/api/host/${tenantId}/sales/notes/${appHelpers.url.encode(setCode)}/${appHelpers.url.encode(searchKey)}`;
        return Vue.http.post(self.fixUrl(url), noteLines);
      },
      getPurchasingNotes(tenantId, setCode, searchKey) {
        let url = `/api/host/${tenantId}/purchasing/notes/${appHelpers.url.encode(setCode)}/${appHelpers.url.encode(searchKey)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsertPurchasingNotes(tenantId, setCode, searchKey, noteLines) {
        let url = `/api/host/${tenantId}/purchasing/notes/${appHelpers.url.encode(setCode)}/${appHelpers.url.encode(searchKey)}`;
        return Vue.http.post(self.fixUrl(url), noteLines);
      },
      getSalesDescriptions(tenantId, setCode, searchKey) {
        let url = `/api/host/${tenantId}/sales/descriptions/${appHelpers.url.encode(setCode)}/${appHelpers.url.encode(searchKey)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      getPurchasingDescriptions(tenantId, setCode, searchKey) {
        let url = `/api/host/${tenantId}/purchasing/descriptions/${appHelpers.url.encode(setCode)}/${appHelpers.url.encode(searchKey)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      getProductionDescriptions(tenantId, setCode, searchKey) {
        let url = `/api/host/${tenantId}/production/descriptions/${appHelpers.url.encode(setCode)}/${appHelpers.url.encode(searchKey)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      getMaterialDescriptions(tenantId, setCode, searchKey) {
        let url = `/api/host/${tenantId}/material/descriptions/${appHelpers.url.encode(setCode)}/${appHelpers.url.encode(searchKey)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      getGWNotes(tenantId, tableName, searchKey1, searchKey2) {
        let url = `/api/host/${tenantId}/gw/notes/${appHelpers.url.encode(tableName)}/${appHelpers.url.encode(searchKey1)}`;
        if (searchKey2) {
          url += `/${appHelpers.url.encode(searchKey2)}`;
        }
        return Vue.http.get(self.fixUrl(url));
      },
      upsertGWNotes(tenantId, tableName, searchKey1, searchKey2, notes) {
        let url = `/api/host/${tenantId}/gw/notes/${appHelpers.url.encode(tableName)}/${appHelpers.url.encode(searchKey1)}`;
        if (searchKey2) {
          url += `/${appHelpers.url.encode(searchKey2)}`;
        }
        return Vue.http.put(self.fixUrl(url), { notes: notes }, { emulateJSON: true });
      }
    },
    cableTrayQuote: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/cableTrayQuote/search`;
        let params = {};
        Object.assign(params, filters);
        if (params.salesPeople) {
          params.salesPeople = params.salesPeople.toString();
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      get(tenantId, number) {
        let url = `/api/host/${tenantId}/cableTrayQuote/${appHelpers.url.encode(number)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      getDetails(tenantId, number) {
        let url = `/api/host/${tenantId}/cableTrayQuote/${appHelpers.url.encode(number)}/detail`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/cableTrayQuote/`;
        if (record.QUOTE_NUMBER_QM) {
          url += record.QUOTE_NUMBER_QM;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
      approve(tenantId, quoteNumber, approvedStatus, quoteNotes) {
        let url = `/api/host/${tenantId}/cableTrayQuote/${quoteNumber}/approve`;
        return Vue.http.post(self.fixUrl(url), { approvedStatus: approvedStatus, quoteNotes: quoteNotes }, { emulateJSON: true });
      },
      updateCustomer(tenantId, quoteNumber, customerNumber) {
        let url = `/api/host/${tenantId}/cableTrayQuote/${quoteNumber}/updateCustomer`;
        return Vue.http.post(self.fixUrl(url), { customerNumber: customerNumber }, { emulateJSON: true });
      },
      listFullBOM(tenantId, quoteNumber, maxLevel, looseMatch, ignoreLength, hideFull, hideFlat) {
        let url = `/api/host/${tenantId}/cableTrayQuote/${appHelpers.url.encode(quoteNumber)}/fullBOM`;
        let params = {};
        if (maxLevel) {
          params.maxLevel = maxLevel;
        }
        if (typeof(looseMatch) === "boolean") {
          params.looseMatch = looseMatch;
        }
        if (typeof(ignoreLength) === "boolean") {
          params.ignoreLength = ignoreLength;
        }
        if (typeof(hideFull) === "boolean") {
          params.hideFull = hideFull;
        }
        if (typeof(hideFlat) === "boolean") {
          params.hideFlat = hideFlat;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, customerNumber, numberPrefix, projectName, recordLimit) {
        let url = `/api/host/${tenantId}/cableTrayQuote/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        if (customerNumber) {
          params["customerNumber"] = customerNumber;
        }
        if (projectName) {
          params["projectName"] = projectName;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.cableTrayQuote.filterPreviousRequest) {
            self.host.cableTrayQuote.filterPreviousRequest.abort();
          }
  
          self.host.cableTrayQuote.filterPreviousRequest = request;
        }});
      },
      getBulk(tenantId, quoteNumbers) {
        let url = `/api/host/${tenantId}/cableTrayQuote/bulk`;
        let params = { quoteNumbers: quoteNumbers };
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      createOpportunity(tenantId, quoteNumber) {
        let url = `/api/host/${tenantId}/cableTrayQuote/${appHelpers.url.encode(quoteNumber)}/createOpportunity`;
        return Vue.http.post(self.fixUrl(url));
      },
    },
    cableTrayPrefix: {
      list(tenantId) {
        let url = `/api/host/${tenantId}/cableTrayPrefix`;
        let params = { };
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      get(tenantId, prefixType) {
        let url = `/api/host/${tenantId}/cableTrayPrefix/${appHelpers.url.encode(prefixType)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/cableTrayPrefix/`;
        if (record.PREFIX_TYPE_QN) {
          url += record.PREFIX_TYPE_QN;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
      delete(tenantId, prefixType) {
        let url = `/api/host/${tenantId}/cableTrayPrefix/${appHelpers.url.encode(prefixType)}`;
        return Vue.http.delete(self.fixUrl(url));
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, recordLimit) {
        let url = `/api/host/${tenantId}/cableTrayPrefix/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.cableTrayPrefix.filterPreviousRequest) {
            self.host.cableTrayPrefix.filterPreviousRequest.abort();
          }
  
          self.host.cableTrayPrefix.filterPreviousRequest = request;
        }});
      },
    },
    cableBusQuote: {
      createOpportunity(tenantId, quoteNumber) {
        let url = `/api/host/${tenantId}/cableBusQuote/${appHelpers.url.encode(quoteNumber)}/createOpportunity`;
        return Vue.http.post(self.fixUrl(url));
      },
      listFullBOM(tenantId, quoteId, maxLevel, looseMatch, ignoreLength, hideFull, hideFlat) {
        let url = `/api/host/${tenantId}/cableBusQuote/${quoteId}/fullBOM`;
        let params = {};
        if (maxLevel) {
          params.maxLevel = maxLevel;
        }
        if (typeof(looseMatch) === "boolean") {
          params.looseMatch = looseMatch;
        }
        if (typeof(ignoreLength) === "boolean") {
          params.ignoreLength = ignoreLength;
        }
        if (typeof(hideFull) === "boolean") {
          params.hideFull = hideFull;
        }
        if (typeof(hideFlat) === "boolean") {
          params.hideFlat = hideFlat;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
    },
    issue: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/issue/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    issueSummary: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/issueSummary/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    poItem: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/poitem/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateDateRescheduled(tenantId, poNumber, itemNumber, dateRescheduled, rollingVendorName)
      {
        let url = `/api/host/${tenantId}/poitem/${appHelpers.url.encode(poNumber)}/${appHelpers.url.encode(itemNumber)}/update-date-rescheduled`;
        let params = {};
        if (dateRescheduled)  {
          params.dateRescheduled = dateRescheduled;
        }
        if (rollingVendorName != null) {
          params.rollingVendorName = rollingVendorName;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      updateDateRescheduledMass(tenantId, pos, items, newDate)
      {
        let url = `/api/host/${tenantId}/poitem/action/update-date-rescheduled-mass`;
        let payload = {
          pos: pos.join(','),
          items: items.join(','),
        };
        let params = {
          newDate: newDate
        };
        return Vue.http.post(self.fixUrl(url), payload, { params: params });
      },
      updateDates(tenantId, releases, items, jobs, newDate) {
        let url = `/api/host/${tenantId}/forecasting/action/updateDates`;
        let payload = {
          releases: releases.join(','),
          items: items.join(','),
          jobs: jobs.join(','),
        };
        let params = {
          newDate: newDate
        };
        return Vue.http.post(self.fixUrl(url), payload, { params: params });
      },
    },
    po: {
      filterPreviousRequest: null,
      filter(tenantId, searchText, vendorNumber, recordLimit) {
        let url = `/api/host/${tenantId}/po/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (vendorNumber) {
          params["vendorNumber"] = vendorNumber;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.po.filterPreviousRequest) {
            self.host.po.filterPreviousRequest.abort();
          }
  
          self.host.po.filterPreviousRequest = request;
        }});
      },
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/po/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateApproval(tenantId, record) {
        let url = `/api/host/${tenantId}/po/${appHelpers.url.encode(record.PO_NUMBER_POMSTR)}/approval`;
        return Vue.http.put(self.fixUrl(url), record);
      },
      updateBuyerStatus(tenantId, poNumber, buyer, status) {
        let url = `/api/host/${tenantId}/po/${appHelpers.url.encode(poNumber)}/update-buyer-status`;
        let params = { buyer, status };
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
    },
    labor: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/labor/search`;
        let params = {};
        Object.assign(params, filters);
        if (params.categories) {
          params.categories = params.categories.toString();
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
    },
    costRevenue: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/costRevenue/search`;
        let params = {};
        Object.assign(params, filters);
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
    },
    workOrder: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/wo/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      searchBOM(tenantId, filters) {
        let url = `/api/host/${tenantId}/wobom/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateBOMPOs(tenantId, releaseWOs, items, poNumber, poItemNumber) {
        let url = `/api/host/${tenantId}/wobom/action/updatePO`;
        let payload = {
          releaseWOs: releaseWOs.join(','),
          items: items.join(','),
        };
        let params = {
          poNumber: poNumber,
          poItemNumber: poItemNumber
        };
        return Vue.http.post(self.fixUrl(url), payload, { params: params });
      },
      updateBOMPaints(tenantId, jobNumber, boms) {
        let url = `/api/host/${tenantId}/wobom/action/updatePaints/${jobNumber}`;
        return Vue.http.post(self.fixUrl(url), boms);
      },
      searchOperation(tenantId, filters) {
        let url = `/api/host/${tenantId}/woop/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      toggleOperationReleaseCodes(tenantId, releases, workOrders, operations) {
        let url = `/api/host/${tenantId}/woop/toggleReleaseCodes`
        let payload = {
          releases: releases,
          workOrders: workOrders,
          operations: operations
        };
        let params = { };
        return Vue.http.post(self.fixUrl(url), payload, { params: params });
      },
      updateOperationWorkCenters(tenantId, releases, workOrders, operations, newWorkCenter) {
        let url = `/api/host/${tenantId}/woop/updateWorkCenter/${newWorkCenter}`
        let payload = {
          releases: releases,
          workOrders: workOrders,
          operations: operations
        };
        let params = { };
        return Vue.http.post(self.fixUrl(url), payload, { params: params });
      },
      getWorkCenters(tenantId) {
        let url = `/api/host/${tenantId}/workcenter`;
        return Vue.http.get(self.fixUrl(url), { });
      },
      searchWorkCenters(tenantId, filters) {
        let url = `/api/host/${tenantId}/workcenter/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateWorkCenterCapHours(tenantId, workCenter, capHours) {
        let url = `/api/host/${tenantId}/workcenter/${workCenter}/update-cap-hours`
        let params = {
          capHours: capHours
        };
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      listEngineerHours(tenantId, filters) {
        let url = `/api/host/${tenantId}/engineerHours`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      listOutstandingOperations(tenantId, releaseNumber, workOrder) {
        let url = `/api/host/${tenantId}/release/${releaseNumber}/${workOrder}/operations`
        return Vue.http.get(self.fixUrl(url));
      },
      updatePriorityDate(tenantId, releaseWO, priority, completeDate, begunDate) {
        let url = `/api/host/${tenantId}/wo/update-priority-date`
        let params = {
          releaseWO: releaseWO,
          priority: priority,
          completeDate: completeDate,
          begunDate: begunDate,
        };
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      updateBay(tenantId, releaseWO, operation, bay) {
        let url = `/api/host/${tenantId}/wo/update-bay`
        let params = {
          releaseWO: releaseWO,
          operation: operation,
          bay: bay,
        };
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      updateStatus(tenantId, releaseWO, status) {
        let url = `/api/host/${tenantId}/wo/update-status`
        let params = {
          releaseWO: releaseWO,
          status: status,
        };
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      listOperationsByWorkCenter(tenantId, filters) {
        let url = `/api/host/${tenantId}/woop/list-by-workcenter`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateOperationsByWorkCenter(tenantId, filters, records) {
        let url = `/api/host/${tenantId}/woop/update-by-workcenter`;
        return Vue.http.post(self.fixUrl(url), records, { params: filters });
      },
      listOperationsByReleaseCategory(tenantId, filters) {
        let url = `/api/host/${tenantId}/woop/list-by-release-category`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateOperationsByReleaseCategory(tenantId, filters, records) {
        let url = `/api/host/${tenantId}/woop/update-by-release-category`;
        return Vue.http.post(self.fixUrl(url), records, { params: filters });
      },
    },
    workOrderSummary: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/woSummary/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      searchByLength(tenantId, filters) {
        let url = `/api/host/${tenantId}/woSummaryByLength/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      }
    },
    releaseDetail: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/releasedetail/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateSchedule(tenantId, record) {
        let url = `/api/host/${tenantId}/releasedetail/schedule`;
        return Vue.http.post(self.fixUrl(url), record);
      },
    },
    shipmentDetail: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/shipmentdetail/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    shipmentMaster: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/shipmentmaster/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    shipmentSchedule: {
      list(tenantId) {
        let url = `/api/host/${tenantId}/shipmentschedule`;
        return Vue.http.get(self.fixUrl(url));
      },
    },
    engineeringAssignments: {
      list(tenantId, forceBaseReleases) {
        let url = `/api/host/${tenantId}/engineeringAssignments`;
        let params = { };
        if (forceBaseReleases) {
          params.forceBaseReleases = true;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      assign(tenantId, release) {
        let url = `/api/host/${tenantId}/engineeringAssignments/assign`;
        return Vue.http.post(self.fixUrl(url), release);
      }
    },
    receipt: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/receipt/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    customer: {
      get(tenantId, number) {
        let url = `/api/host/${tenantId}/customer/${appHelpers.url.encode(number)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/customer/`;
        if (record.CUSTOMER_NUMBER_CSTM) {
          url += record.CUSTOMER_NUMBER_CSTM;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, numberPrefix, group, recordLimit) {
        let url = `/api/host/${tenantId}/customer/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        if (group) {
          params["group"] = group;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.customer.filterPreviousRequest) {
            self.host.customer.filterPreviousRequest.abort();
          }
  
          self.host.customer.filterPreviousRequest = request;
        }});
      },
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/customer/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    arPayment: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/ar-payment/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    customerInvoice: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/customerinvoice/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, jobNumber, recordLimit) {
        let url = `/api/host/${tenantId}/customerinvoice/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (jobNumber) {
          params["jobNumber"] = jobNumber;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.customerInvoice.filterPreviousRequest) {
            self.host.customerInvoice.filterPreviousRequest.abort();
          }
  
          self.host.customerInvoice.filterPreviousRequest = request;
        }});
      },
      listLines(tenantId, invoiceNumber) {
        let url = `/api/host/${tenantId}/customerinvoice/${invoiceNumber}/lines`;
        return Vue.http.get(self.fixUrl(url));
      },
      update(tenantId, invoiceNumber, record) {
        let url = `/api/host/${tenantId}/customerinvoice/${appHelpers.url.encode(invoiceNumber)}`;
        return Vue.http.put(self.fixUrl(url), record);
      }
    },
    vendorInvoice: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/vendorinvoice/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    apInvoice: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/ap-invoice/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    apInvoiceAdjust: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/ap-invoice-adjust/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    glAccountTransaction: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/gl-account-transaction/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    job: {
      filterPreviousRequest: null,
      filter(tenantId, searchText, numberPrefix, recordLimit, showAccounting, openOnly) {
        let url = `/api/host/${tenantId}/job/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        if (showAccounting) {
          params["showAccounting"] = showAccounting;
        }
        if (openOnly) {
          params["openOnly"] = openOnly;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.job.filterPreviousRequest) {
            self.host.job.filterPreviousRequest.abort();
          }
  
          self.host.job.filterPreviousRequest = request;
        }});
      },
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/job/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      searchStock(tenantId, filters) {
        let url = `/api/host/${tenantId}/stockJob/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      listEstimateSummaries(tenantId, job, category) {
        let url = `/api/host/${tenantId}/jobestimatesummary/${appHelpers.url.encode(job)}`;
        if (category) {
          url += `/${appHelpers.url.encode(category)}`;
        }
        return Vue.http.get(self.fixUrl(url));
      },
      listEstimateChanges(tenantId, filters) {
        let url = `/api/host/${tenantId}/jobestimate/changes/${appHelpers.url.encode(filters.job)}`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      listEstimateAnalysisCategories(tenantId) {
        let url = `/api/host/${tenantId}/jobestimateanalysis/categories`;
        return Vue.http.get(self.fixUrl(url));
      },
      searchEstimateAnalysis(tenantId, filters) {
        let url = `/api/host/${tenantId}/jobestimateanalysis/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      listReleasesFull(tenantId, job, release) {
        let url = `/api/host/${tenantId}/job/${appHelpers.url.encode(job)}/releases`;
        if (release) {
          url += `/${appHelpers.url.encode(release)}`;
        }
        return Vue.http.get(self.fixUrl(url));
      },
      siteInventory: {
        search(tenantId, filters) {
          let url = `/api/host/${tenantId}/job/site/inventory/search`;
          return Vue.http.get(self.fixUrl(url), { params: filters });
        },
        update(tenantId, record) {
          let url = `/api/host/${tenantId}/job/site/inventory`;
          return Vue.http.put(self.fixUrl(url), record);
        },
      },
      listEstimateOutstandingDetails(tenantId, job, category, jobMatchType, clsRstC, clsRstR, clsRstX, clsRstJ, clsRstN, clsRstIgnore, customerNumber, customerNumberMatchType, customerName, customerNameMatchType, excludeFeeItems, excludeFinishItems, excludeBaggingItems, excludeToolingItems, excludeRCStatus, excludeSubContr, priority) {
        let url = `/api/host/${tenantId}/jobestimatesummary/outstanding/`;
        let filters = {
          job: job || null,
          category: category || null,
          jobMatchType: jobMatchType || null,
          clsRstC: clsRstC || false,
          clsRstR: clsRstR || false,
          clsRstX: clsRstX || false,
          clsRstJ: clsRstJ || false,
          clsRstN: clsRstN || false,
          clsRstIgnore: clsRstIgnore || false,
          customerName: customerName || null,
          customerNameMatchType: customerNameMatchType || 'StartsWith',
          customerNumber: customerNumber || null,
          customerNumberMatchType: customerNumberMatchType || 'StartsWith',
          excludeFeeItems: excludeFeeItems || false,
          excludeFinishItems: excludeFinishItems || false,
          excludeBaggingItems: excludeBaggingItems || false,
          excludeToolingItems: excludeToolingItems || false,
          excludeRCStatus: excludeRCStatus || false,
          excludeSubContr: excludeSubContr || false,
          priority: priority || null,
        };
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      listEstimateActualDetails(tenantId, job, category) {
        let url = `/api/host/${tenantId}/jobestimatesummary/${appHelpers.url.encode(job)}/actual/${appHelpers.url.encode(category || '')}`;
        return Vue.http.get(self.fixUrl(url));
      },
      getQuoteDetails(tenantId, jobNumber, quoteNumber) {
        let url = `/api/host/${tenantId}/job/analysis/quotes`;
        let filters = {
          jobNumber: jobNumber
        };
        if (quoteNumber) {
          filters['quoteNumber'] = quoteNumber;
        }
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      getProposalDetails(tenantId, jobNumber) {
        let url = `/api/host/${tenantId}/job/analysis/proposals`;
        let filters = {
          jobNumber: jobNumber
        };
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      toggleJobStatuses(tenantId, cJobNumbers, rJobNumbers, xJobNumbers) {
        let url = `/api/host/${tenantId}/job/toggleStatuses`
        let params = {
          cJobNumbers: cJobNumbers,
          rJobNumbers: rJobNumbers,
          xJobNumbers: xJobNumbers
        };
        return Vue.http.post(self.fixUrl(url), params);
      },
      insertJobStatuses(tenantId, jobType, showAccounting, cJobNumbers, rJobNumbers, xJobNumbers) {
        let url = `/api/host/${tenantId}/job/insertStatuses`
        let params = {
          jobType: jobType,
          showAccounting: showAccounting,
          cJobNumbers: cJobNumbers,
          rJobNumbers: rJobNumbers,
          xJobNumbers: xJobNumbers,
        };
        return Vue.http.post(self.fixUrl(url), params);
      },
      searchShopLoadCombined(tenantId, filters, categories) {
        let url = `/api/host/${tenantId}/shopLoad/combined`;
        return Vue.http.post(self.fixUrl(url), categories, { params: filters });
      },
      searchShopLoadCombinedDetail(tenantId, filters, categories) {
        let url = `/api/host/${tenantId}/shopLoad/combined/detail`;
        return Vue.http.post(self.fixUrl(url), categories, { params: filters });
      },
      listReviewable(tenantId, filters) {
        let url = `/api/host/${tenantId}/job/reviewable`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      listReviewableStock(tenantId, filters) {
        let url = `/api/host/${tenantId}/stockJob/reviewable`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      searchWorkCenterLoadCombined(tenantId, filters) {
        let url = `/api/host/${tenantId}/workCenterLoad/combined`;
        return Vue.http.post(self.fixUrl(url), null, { params: filters });
      },
      searchWorkCenterLoadByWorkCenters(tenantId, workCenters) {
        let url = `/api/host/${tenantId}/workCenterLoad/combined/byWorkCenters`;
        return Vue.http.post(self.fixUrl(url), null, { params: { workCenters: workCenters } });
      },
      searchWorkCenterLoadCombinedDetail(tenantId, filters) {
        let url = `/api/host/${tenantId}/workCenterLoad/combined/detail`;
        return Vue.http.post(self.fixUrl(url), null, { params: filters });
      },
      update(tenantId, record) {
        let url = `/api/host/${tenantId}/job`;
        return Vue.http.post(self.fixUrl(url), record);
      },
    },
    release: {
      filterPreviousRequest: null,
      filter(tenantId, searchText, numberPrefix, recordLimit, showAccounting) {
        let url = `/api/host/${tenantId}/release/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        if (showAccounting) {
          params["showAccounting"] = showAccounting;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.release.filterPreviousRequest) {
            self.host.release.filterPreviousRequest.abort();
          }
  
          self.host.release.filterPreviousRequest = request;
        }});
      },
      listTasks(tenantId, releaseNumber) {
        let url = `/api/host/${tenantId}/release/${releaseNumber}/tasks`;
        return Vue.http.get(self.fixUrl(url));
      },
      updateTasks(tenantId, releaseNumber, records) {
        let url = `/api/host/${tenantId}/release/${releaseNumber}/tasks`;
        return Vue.http.put(self.fixUrl(url), records);
      },
      upsertShippingNote(tenantId, releaseNumber, shippingNote) {
        let url = `/api/host/${tenantId}/release/${releaseNumber}/shipping-note`;
        return Vue.http.put(self.fixUrl(url), { shippingNote: shippingNote }, { emulateJSON: true });
      },
      getEngineeringNotes(tenantId, releaseNumber) {
        let url = `/api/host/${tenantId}/release/${releaseNumber}/engineering-note`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsertEngineeringNotes(tenantId, releaseNumber, engineeringNote) {
        let url = `/api/host/${tenantId}/release/${releaseNumber}/engineering-note`;
        return Vue.http.put(self.fixUrl(url), { engineeringNote: engineeringNote }, { emulateJSON: true });
      },
      listForecasts(tenantId, jobNumber, minScheduleDate, maxScheduleDate, hideZeroForecastLines, hideInvalidPriorities) {
        let params = { };
        if (minScheduleDate) {
          params.minScheduleDate = minScheduleDate;
        }
        if (maxScheduleDate) {
          params.minScheduleDate = maxScheduleDate;
        }
        if (hideZeroForecastLines) {
          params.hideZeroForecastLines = hideZeroForecastLines;
        }
        if (hideInvalidPriorities) {
          params.hideInvalidPriorities = hideInvalidPriorities;
        }
        let url = `/api/host/${tenantId}/releaseForecast/${jobNumber}`;
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      upsertForecasts(tenantId, jobNumber, records) {
        let url = `/api/host/${tenantId}/releaseForecast/${jobNumber}`;
        return Vue.http.post(self.fixUrl(url), records);
      },
    },
    changeOrder: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/changeorder/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      get(tenantId, jobNumber, itemNumber) {
        let url = `/api/host/${tenantId}/changeorder/${jobNumber}/${itemNumber}`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/changeorder/`;
        return Vue.http.put(self.fixUrl(url), record);
      }
    },
    item: {
      filterPreviousRequest: null,
      filter(tenantId, searchText, recordLimit, recType, numberPrefix, category) {
        let url = `/api/host/${tenantId}/item/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (recType) {
          params["recType"] = recType;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        if (category) {
          params["category"] = category;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.item.filterPreviousRequest) {
            self.host.item.filterPreviousRequest.abort();
          }
  
          self.host.item.filterPreviousRequest = request;
        }});
      },
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/item/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      get(tenantId, catalogueNumber, locationCode) {
        let url = `/api/host/${tenantId}/catalogue/${appHelpers.url.encode(catalogueNumber)}`;
        let params = {};
        if (locationCode)  {
          params.locationCode = locationCode;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      getMaterial(tenantId, catalogueNumber, locationCode) {
        let url = `/api/host/${tenantId}/catalogue/${appHelpers.url.encode(catalogueNumber)}/material`;
        let params = {};
        if (locationCode)  {
          params.locationCode = locationCode;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      getInventory(tenantId, catalogueNumber, locationCode) {
        let url = `/api/host/${tenantId}/catalogue/${appHelpers.url.encode(catalogueNumber)}/inventory`;
        let params = {};
        if (locationCode)  {
          params.locationCode = locationCode;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      listMRP(tenantId, catalogueNumber, locationCode, filters) {
        let url = `/api/host/${tenantId}/item/${appHelpers.url.encode(catalogueNumber)}/mrp/${appHelpers.url.encode(locationCode)}`;
        let params = {};
        Object.assign(params, filters);
        delete params.catalogueNumber;
        delete params.locationCode;
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      listFullBOM(tenantId, catalogueNumber, maxLevel) {
        let url = `/api/host/${tenantId}/item/${appHelpers.url.encode(catalogueNumber)}/fullBOM`;
        let params = {};
        if (maxLevel) {
          params.maxLevel = maxLevel;
        }
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      searchLotInventory(tenantId, filters) {
        let url = `/api/host/${tenantId}/lotinventory/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      lotInventoryUpdate(tenantId, LOT_NUMBER_LOTINV, LENGTH_LOTINV, WIDTH_LOTINV) {
        let url = `/api/host/${tenantId}/lotinventory/update/${LOT_NUMBER_LOTINV}`;
        
        return Vue.http.post(self.fixUrl(url), { LENGTH_LOTINV, WIDTH_LOTINV });
      },
      listLotTags(tenantId, lotNumber) {
        let url = `/api/host/${tenantId}/lottags/${lotNumber}`;
        return Vue.http.get(self.fixUrl(url));
      },
      listQuoteDetails(tenantId, catalogueNumber) {
        let url = `/api/host/${tenantId}/item/${appHelpers.url.encode(catalogueNumber)}/quoteDetails`;
        return Vue.http.get(self.fixUrl(url));
      },
      getCatalogueInfo(tenantId, catalogueNumber) {
        let url = `/api/host/${tenantId}/item/${appHelpers.url.encode(catalogueNumber)}/info`;
        return Vue.http.get(self.fixUrl(url));
      },
      searchPaint(tenantId, filters) {
        let url = `/api/host/${tenantId}/paintitem/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      listPaintJobs(tenantId, filters) {
        let url = `/api/host/${tenantId}/paintitem/list-jobs`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      listPaintJobsSummary(tenantId, filters) {
        let url = `/api/host/${tenantId}/paintitem/job-summary`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      inventoryUpdateStockLevelMin(tenantId, stockNumber, stockLevelMin) {
        let url = `/api/host/${tenantId}/inventory/${appHelpers.url.encode(stockNumber)}/update-stock-level-min`;
        let params = {};
        if (stockLevelMin)  {
          params.stockLevelMin = stockLevelMin;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      inventoryUpdateAttributes(tenantId, catalogueNumber, payload) {
        let url = `/api/host/${tenantId}/inventory/${appHelpers.url.encode(catalogueNumber)}/update-attributes`;
        return Vue.http.post(self.fixUrl(url), payload);
      },
      inventoryUpdateNotes(tenantId, catalogueNumber, notes, type, locationCode) {
        let url = `/api/host/${tenantId}/inventory/${appHelpers.url.encode(catalogueNumber)}/update-notes`;
        let payload = { notes: notes, type: type, locationCode: locationCode };
        return Vue.http.post(self.fixUrl(url), payload);
      },
      partUpdateUnitCost(tenantId, catalogueNumber, unitCost)
      {
        let url = `/api/host/${tenantId}/part/${appHelpers.url.encode(catalogueNumber)}/update-unit-cost`;
        let params = {};
        if (unitCost)  {
          params.unitCost = unitCost;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      partUpdateFutureStdCost(tenantId, catalogueNumber, futureStdCost)
      {
        let url = `/api/host/${tenantId}/part/${appHelpers.url.encode(catalogueNumber)}/update-future-std-cost`;
        let params = {};
        if (futureStdCost)  {
          params.futureStdCost = futureStdCost;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      materialUpdateUnitCosts(tenantId, catalogueNumber, catClass, unitCost) {
        let url = `/api/host/${tenantId}/material/update-unit-costs`;
        let params = {};
        if (catalogueNumber) {
          params["catalogueNumber"] = catalogueNumber;
        }
        if (catClass) {
          params["catClass"] = catClass;
        }
        if (unitCost) {
          params["unitCost"] = unitCost;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      materialUpdateUnitCostsSpecific(tenantId, catalogues, catClass, unitCost) {
        let url = `/api/host/${tenantId}/material/update-unit-costs-specific`;
        let params = {};
        let payload = {
          catalogues: catalogues.join(',')
        };
        if (catClass) {
          params["catClass"] = catClass;
        }
        if (unitCost) {
          params["unitCost"] = unitCost;
        }
        return Vue.http.post(self.fixUrl(url), payload, { params: params });
      },
      materialUpdateRequirements(tenantId) {
        let url = `/api/host/${tenantId}/material/update-requirements`;
        return Vue.http.post(self.fixUrl(url), null);
      },
      componentUpdateUnitCost(tenantId, catalogueNumber, unitCost)
      {
        let url = `/api/host/${tenantId}/component/${appHelpers.url.encode(catalogueNumber)}/update-unit-cost`;
        let params = {};
        if (unitCost)  {
          params.unitCost = unitCost;
        }
        return Vue.http.post(self.fixUrl(url), null, { params: params });
      },
      toggleABC(tenantId, catalogueNumber)
      {
        let url = `/api/host/${tenantId}/item/${catalogueNumber}/action/toggleABC`;
        return Vue.http.post(self.fixUrl(url), null);
      },
    },
    cableTrayItem: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/cabletrayitem/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    customerContact: {
      list(tenantId, customer) {
        let url = `/api/host/${tenantId}/customer/${appHelpers.url.encode(customer)}/contact`;
        return Vue.http.get(self.fixUrl(url));
      },
      get(tenantId, customer, contact) {
        let url = `/api/host/${tenantId}/customer/${appHelpers.url.encode(customer)}/contact/${appHelpers.url.encode(contact)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, recordLimit, customer) {
        let url = `/api/host/${tenantId}/customer/${appHelpers.url.encode(customer)}/contact/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.customerContact.filterPreviousRequest) {
            self.host.customerContact.filterPreviousRequest.abort();
          }
  
          self.host.customerContact.filterPreviousRequest = request;
        }});
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/customer/${appHelpers.url.encode(record.CUSTOMER_NUMBER_CONTACT)}/contact/`;
        if (record.ITEM_NUMBER_CONTACT) {
          url += record.ITEM_NUMBER_CONTACT;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
      delete(tenantId, customer, contact) {
        let url = `/api/host/${tenantId}/customer/${appHelpers.url.encode(customer)}/contact/${contact}`;
        return Vue.http.delete(self.fixUrl(url));
      },
    },
    vendorContact: {
      list(tenantId, vendor) {
        let url = `/api/host/${tenantId}/vendor/${appHelpers.url.encode(vendor)}/contact`;
        return Vue.http.get(self.fixUrl(url));
      },
      get(tenantId, vendor, contact) {
        let url = `/api/host/${tenantId}/vendor/${appHelpers.url.encode(vendor)}/contact/${appHelpers.url.encode(contact)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, recordLimit, vendor, showAccounting) {
        let url = `/api/host/${tenantId}/vendor/${appHelpers.url.encode(vendor)}/contact/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (showAccounting) {
          params["showAccounting"] = showAccounting;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.vendorContact.filterPreviousRequest) {
            self.host.vendorContact.filterPreviousRequest.abort();
          }
  
          self.host.vendorContact.filterPreviousRequest = request;
        }});
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/vendor/${appHelpers.url.encode(record.VENDOR_NUMBER_VENDCT)}/contact/`;
        if (record.ITEM_NUMBER_VENDCT) {
          url += record.ITEM_NUMBER_VENDCT;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
      delete(tenantId, vendor, contact) {
        let url = `/api/host/${tenantId}/vendor/${appHelpers.url.encode(vendor)}/contact/${contact}`;
        return Vue.http.delete(self.fixUrl(url));
      },
    },
    operation: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/operation/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      update(tenantId, record) {
        let url = `/api/host/${tenantId}/operation`;
        return Vue.http.post(self.fixUrl(url), record);
      },
      massUpdate(tenantId, updates, catalogues, operations) {
        let url = `/api/host/${tenantId}/operations`;
        return Vue.http.post(self.fixUrl(url), { catalogues, operations }, { params: updates });
      },
    },
    subComponent: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/subcomponent/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    component: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/component/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      incorrectPSM(tenantId, filters) {
        let url = `/api/host/${tenantId}/component/incorrectPSM`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      incorrectPSMFix(tenantId) {
        let url = `/api/host/${tenantId}/component/incorrectPSM/fix`;
        return Vue.http.post(self.fixUrl(url));
      },
    },
    part: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/part/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      incorrectPSM(tenantId, filters) {
        let url = `/api/host/${tenantId}/part/incorrectPSM`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      incorrectPSMFix(tenantId) {
        let url = `/api/host/${tenantId}/part/incorrectPSM/fix`;
        return Vue.http.post(self.fixUrl(url));
      },
    },
    partCost: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/part/cost/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    materialCost: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/material/cost/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      }
    },
    activity: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/activity/search`;
        let params = {};
        Object.assign(params, filters);
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      get(tenantId, number) {
        let url = `/api/host/${tenantId}/activity/${appHelpers.url.encode(number)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/activity/`;
        if (record.ACTIVITY_CODE_ZA) {
          url += record.ACTIVITY_CODE_ZA;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
    },
    vendor: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/vendor/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      filterPreviousRequest: null,
      filter(tenantId, searchText, numberPrefix, recordLimit) {
        let url = `/api/host/${tenantId}/vendor/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.vendor.filterPreviousRequest) {
            self.host.vendor.filterPreviousRequest.abort();
          }
  
          self.host.vendor.filterPreviousRequest = request;
        }});
      },
      getLists(tenantId, number) {
        let url = `/api/host/${tenantId}/vendor/${appHelpers.url.encode(number)}/lists`;
        return Vue.http.get(self.fixUrl(url));
      },
      updateLists(tenantId, number, record) {
        let url = `/api/host/${tenantId}/vendor/${appHelpers.url.encode(number)}/lists`;
        return Vue.http.put(self.fixUrl(url), record);
      }
    },
    freightAnalysis: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/freightAnalysis/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      getDetail(tenantId, jobNumber) {
        let url = `/api/host/${tenantId}/freightAnalysis/${jobNumber}/detail`;
        return Vue.http.get(self.fixUrl(url));
      }
    },
    quoteAnalysis: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/quote/analysis`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      getDetail(tenantId, filters) {
        let url = `/api/host/${tenantId}/quote/analysis/detail`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      }
    },
    releaseAnalysis: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/releaseAnalysis/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      update(tenantId, record) {
        let url = `/api/host/${tenantId}/releaseAnalysis/update`;
        return Vue.http.post(self.fixUrl(url), record);
      }
    },
    forecasting: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/forecasting/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateDates(tenantId, releases, items, jobs, newDate) {
        let url = `/api/host/${tenantId}/forecasting/action/updateDates`;
        let payload = {
          releases: releases.join(','),
          items: items.join(','),
          jobs: jobs.join(','),
        };
        let params = {
          newDate: newDate
        };
        return Vue.http.post(self.fixUrl(url), payload, { params: params });
      },
      closeOpenForecasts(tenantId, releases, items, jobs) {
        let url = `/api/host/${tenantId}/forecasting/action/closeOpenForecasts`;
        let payload = {
          releases: releases.join(','),
          items: items.join(','),
          jobs: jobs.join(','),
        };
        return Vue.http.post(self.fixUrl(url), payload);
      },
      listOrphanedJobs(tenantId, filters) {
        let url = `/api/host/${tenantId}/forecasting/list-orphaned-jobs`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateQuantity(tenantId, forecast) {
        let url = `/api/host/${tenantId}/forecasting/updateQuantity`;
        return Vue.http.post(self.fixUrl(url), forecast);
      }
    },
    projectTracking: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/projectTracking/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      getDetail(tenantId, releaseNumber) {
        let url = `/api/host/${tenantId}/projectTracking/${releaseNumber}`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsertDetail(tenantId, record) {
        let url = `/api/host/${tenantId}/projectTracking/${record.RELEASE_PRJZ}`;
        return Vue.http.post(self.fixUrl(url), record);
      }
    },
    employee: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/employee`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      get(tenantId, employeeNumber) {
        let url = `/api/host/${tenantId}/employee/${employeeNumber}`;
        return Vue.http.get(self.fixUrl(url));
      },
      update(tenantId, record) {
        let url = `/api/host/${tenantId}/employee`;
        if (record.EMPLOYEE_NUMBER_EM) {
          url += `/${record.EMPLOYEE_NUMBER_EM}`
        }
        return Vue.http.post(self.fixUrl(url), record);
      },
    },
    salesPeople: {
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/salesPerson/`;
        return Vue.http.put(self.fixUrl(url), record);
      },
      delete(tenantId, code) {
        let url = `/api/host/${tenantId}/salesPerson/${code}`;
        return Vue.http.delete(self.fixUrl(url));
      }
    },
    system: {
      listDatabaseLocks(tenantId, filters) {
        let url = `/api/host/${tenantId}/system/databaseLocks`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      listHostSessions(tenantId) {
        let url = `/api/host/${tenantId}/system/hostSessions`;
        return Vue.http.get(self.fixUrl(url));
      }
    },
    engineeringChangeNotice: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/engineeringChangeNotice/search`;
        let params = {};
        Object.assign(params, filters);
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      get(tenantId, number) {
        let url = `/api/host/${tenantId}/engineeringChangeNotice/${appHelpers.url.encode(number)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/engineeringChangeNotice/`;
        if (record.ECN_ECN) {
          url += record.ECN_ECN;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
    },
    drawing: {
      filterPreviousRequest: null,
      filter(tenantId, searchText, numberPrefix, recordLimit) {
        let url = `/api/host/${tenantId}/drawing/filter`;
        let params = { };
        if (searchText) {
          params["searchText"] = searchText;
        }
        if (recordLimit) {
          params["recordLimit"] = recordLimit;
        }
        if (numberPrefix) {
          params["numberPrefix"] = numberPrefix;
        }
        return Vue.http.get(self.fixUrl(url), { params: params, before(request) {
          if (self.host.drawing.filterPreviousRequest) {
            self.host.drawing.filterPreviousRequest.abort();
          }
          self.host.drawing.filterPreviousRequest = request;
        }});
      },
    },
    customerPricing: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/customerAgreement/search`;
        let params = {};
        Object.assign(params, filters);
        return Vue.http.get(self.fixUrl(url), { params: params });
      },
      get(tenantId, number) {
        let url = `/api/host/${tenantId}/customerAgreement/${appHelpers.url.encode(number)}`;
        return Vue.http.get(self.fixUrl(url));
      },
      upsert(tenantId, record) {
        let url = `/api/host/${tenantId}/customerAgreement/`;
        if (record.AGREEMENT_AGREE) {
          url += record.AGREEMENT_AGREE;
        }
        return Vue.http.put(self.fixUrl(url), record);
      },
    },
    overview: {
      getShippingOverview(tenantId, params) {
        let url = `/api/host/${tenantId}/shipping/overview`;
        let filters = Object.assign({}, params);
        if (filters.productLines) {
          filters.productLines = filters.productLines.toString();
        }
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      getShippingDetails(tenantId, params) {
        let url = `/api/host/${tenantId}/shipping/overview/details`;
        let filters = Object.assign({}, params);
        if (filters.productLines) {
          filters.productLines = filters.productLines.toString();
        }
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      getBookingBillingOverview(tenantId, params) {
        let url = `/api/host/${tenantId}/bookingBilling/overview`;
        let filters = Object.assign({}, params);
        if (filters.productLines) {
          filters.productLines = filters.productLines.toString();
        }
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      getBookingBillingDetails(tenantId, params) {
        let url = `/api/host/${tenantId}/bookingBilling/overview/details`;
        let filters = Object.assign({}, params);
        if (filters.productLines) {
          filters.productLines = filters.productLines.toString();
        }
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      getRevenueBacklogDetails(tenantId, params) {
        let url = `/api/host/${tenantId}/bookingBilling/overview/revenueBacklog`;
        let filters = Object.assign({}, params);
        if (filters.productLines) {
          filters.productLines = filters.productLines.toString();
        }
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
    },
    maintenanceJob: {
      search(tenantId, filters) {
        let url = `/api/host/${tenantId}/maintenanceJob/search`;
        return Vue.http.get(self.fixUrl(url), { params: filters });
      },
      updateDates(tenantId, record) {
        let url = `/api/host/${tenantId}/maintenanceJob/updateDates`;
        return Vue.http.post(self.fixUrl(url), record);
      }
    },
  },
  importer: {
    uploadFile(tenantId, url, formData, params) {
      return Vue.http.post(self.fixUrl(`/api/import/${tenantId}/${url}`), formData, { params: params });
    },
    getTemplateUrl(tenantId, url, queryString) {
      var templateUrl = self.fixUrl(`/api/import/${tenantId}/${url}`);
      var hasQueryString = (templateUrl.indexOf('?') >= 0);
      for (queryStringKey in queryString) {
        templateUrl += (hasQueryString ? '&' : '?') + queryStringKey + '=' + appHelpers.url.encode(queryString[queryStringKey])
        hasQueryString = true;
      }
      return templateUrl;
    },
    poItemFromReleaseDetail(tenantId, poNumber, records, jobId) {
      let url = `/api/import/${tenantId}/po/${poNumber}/release-detail`;
      let params = { };
      if (jobId){
        params["jobId"] = jobId;
      }
      return Vue.http.post(self.fixUrl(url), records, { params: params }); 
    },
    forecastLineItemFromProposalBOM(tenantId, releaseNumber, proposalNumber, dateNeeded, ignoreLength, records, jobId) {
      let url = `/api/import/${tenantId}/forecasting/${releaseNumber}/import-proposal-flat-bom/${proposalNumber}`;
      let params = { };
      if (jobId) {
        params["jobId"] = jobId;
      }
      if (dateNeeded) {
        params["dateNeeded"] = dateNeeded;
      }
      if (typeof(ignoreLength) === "boolean") {
        params["ignoreLength"] = ignoreLength;
      }
      return Vue.http.post(self.fixUrl(url), records, { params: params }); 
    },
    forecastLineItemFromCableBusQuoteBOM(tenantId, releaseNumber, quoteId, dateNeeded, ignoreLength, records, jobId) {
      let url = `/api/import/${tenantId}/forecasting/${releaseNumber}/import-cable-bus-quote-flat-bom/${quoteId}`;
      let params = { };
      if (jobId) {
        params["jobId"] = jobId;
      }
      if (dateNeeded) {
        params["dateNeeded"] = dateNeeded;
      }
      if (typeof(ignoreLength) === "boolean") {
        params["ignoreLength"] = ignoreLength;
      }
      return Vue.http.post(self.fixUrl(url), records, { params: params }); 
    },
    forecastLineItemDeleteUnReleased(tenantId, releaseNumber) {
      let url = `/api/import/${tenantId}/forecasting/${releaseNumber}/delete-unreleased-release-details`;
      return Vue.http.post(self.fixUrl(url)); 
    }
  },
  report: {
    searchLogs(filters) {
      let url = `/api/report/log/search`;
      return Vue.http.get(self.fixUrl(url), { params: filters });
    }
  },
  audit: {
    searchLogs(filters) {
      let url = `/api/audit/log/search`;
      return Vue.http.get(self.fixUrl(url), { params: filters });
    },
    log(tenantId, action, module, screen, relativeUrl, field) {
      let url = `/api/audit/log`;
      return Vue.http.post(self.fixUrl(url), [{
        companyId: tenantId,
        action: action,
        module: module,
        screen: screen,
        relativeUrl: relativeUrl,
        field: field || ''
      }]);
    },
  },
  state: {
    isAuthorized(tenantId) {
      return Vue.http.get(self.fixUrl(`/api/state/${tenantId}/isAuthorized`));
    }
  },
  token: {
    refresh() {
      return Vue.http.get(self.fixUrl('/token/refresh'));
    }
  }
};